export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      $('.signup-container .emailSignup .emailSignupText').remove();
      $('.signup-container .emailSignup .emailInputField').before(`
        <div class="signup-title">
        <h2>${data.items[0].Title}</h2>
        <span>${data.items[0].Description}</span>
        </div>`);

      $(
        '.signup-container .emailSignup .emailInputField, .signup-container .emailSignup .emailInputSubmit',
      ).wrapAll('<div class="signup-wrap"></div>');

      $('.signup-container .emailSignup .emailInputField input').val('');
      $('.signup-container .emailSignup .emailInputField input').attr(
        'placeholder',
        'Email Address',
      );

      $('.signup-container .emailSignup .emailInputSubmit a').text('Subscribe');
      $(`#${widgetName}`).remove();
    },

    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
  });
}
